import styled from 'styled-components';
import { Modal as ModalComponent } from 'react-bootstrap';

interface IBtnRevealQrCode {
  reveled: boolean;
}

export const Container = styled.div`
  position: relative;
  background: #f4f0ec;

  .infinite-scroll {
    max-height: 100dvh;
    overflow: auto;
    padding-bottom: 20%;
    .padding-bs {
      padding-right: calc(var(--bs-gutter-x) * 0.5);
      padding-left: calc(var(--bs-gutter-x) * 0.5);
    }

    ::-webkit-scrollbar {
      width: 0;
    }

    ::-webkit-scrollbar-thumb {
      background-color: transparent !important;
    }
  }

  .pending {
    position: absolute;
    top: 16px;
    left: 16px;
    z-index: 2;
    pointer-events: none;
  }

  h1 {
    color: #ff6900;
    font-family: 'Poppins';
    font-size: 26px;
    font-weight: 500;
    line-height: 108%;
  }

  h2 {
    color: #002f6c;
    font-weight: 700 !important;
    line-height: 29px !important;
  }

  canvas {
    border-radius: 30px;
  }

  .share {
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 2;
  }

  .line-lower-left,
  .line-upper-left,
  .line-upper-right {
    position: absolute;
    z-index: 1;
  }

  .line-upper-left {
    top: 0;
    left: 0;
    border-right: 4px solid #ff6900;
    border-bottom: 4px solid #ff6900;
    border-bottom-right-radius: 25px;
    height: 30px;
    width: 60%;
  }

  .line-upper-right {
    top: 0;
    right: 0;
    border-left: 4px solid #ff6900;
    border-bottom: 4px solid #ff6900;
    border-bottom-left-radius: 25px;
    height: 80px;
    width: 20%;
  }

  .line-lower-left {
    bottom: 0;
    left: 0;
    border-right: 4px solid #ff6900;
    border-top: 4px solid #ff6900;
    border-top-right-radius: 25px;
    height: 50px;
    width: 60%;
  }

  .bd-qrcode {
    border-radius: 30px;
    border: 10px solid #ff6900;
    padding-bottom: 30px;
    //padding: 36px;
    //background-color: #fff;
  }

  .bg-qr-orange {
    position: absolute;
    background: #ff6900;
    height: 150px;
    width: 100%;
    top: 200px;
    z-index: 1;
  }

  .index {
    z-index: 2;
    position: relative;
  }

  .data {
    color: #002f6c;
    font-size: 14px;
    font-weight: 400;
    span {
      color: #002f6c;
      font-weight: 600;
    }
  }

  .my-ticket {
    color: #fff;
    font-family: 'Roboto';
    font-size: 14px;
    font-weight: 400;

    border-radius: 4px;
    background: #00a3e0;
    min-width: 103px;
  }

  .event p {
    color: #8c8c8c;
    font-size: 14px;
    font-weight: 400;
  }

  .bg-white {
    border-radius: 8px;
  }

  .circle-left {
    width: 10px;
    height: 20px;
    margin-left: -2px;
    //border-radius: 50px;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;

    border-bottom: 2px solid #dfdfdf;
    border-top: 2px solid #dfdfdf;
    border-right: 2px solid #dfdfdf;
    background: #f4f0ec;
  }

  .circle-right {
    width: 10px;
    height: 20px;
    margin-right: -2px;
    //border-radius: 50px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-top: 2px solid #dfdfdf;
    border-bottom: 2px solid #dfdfdf;
    border-left: 2px solid #dfdfdf;
    background: #f4f0ec;
  }

  .small-circle {
    border: 1px solid #dfdfdf;
    width: 6px;
    height: 6px;
    background: #f4f0ec;
    border-radius: 10px;
  }
  .bg-ticket {
    border-radius: 25px;
    border: 4px solid #ff6900;

    background: #fff;

    img {
      width: 150px;
      height: 150px;
    }

    p {
      color: #002f6c;
      font-size: 14px;
      font-weight: 400;
      span {
        color: #002f6c;
        font-weight: 600;
      }
    }

    .ident {
      color: #002f6c;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      line-height: 13px;
      border-radius: 8px;
      //border: 1px solid #002f6c;
      position: absolute;
      bottom: 32px;
      left: 90px;
    }
  }
`;

export const BtnRevealQrCode = styled.button<IBtnRevealQrCode>`
  position: relative;

  .blur {
    position: absolute;
    z-index: 3;
    width: 267px;
    height: 303px;
    border-radius: 20px;
    backdrop-filter: blur(4px);
    top: 76px;
    left: 27px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition-duration: 0.3s;
    opacity: ${(props) => (props.reveled ? '0' : '1')};
    visibility: ${(props) => (props.reveled ? 'hidden' : 'visible')};

    svg {
      path {
        fill: #fff !important;
      }
    }
  }
`;

interface IShareBox {
  show: boolean;
}

interface ICircle {
  color: string;
}

export const ShareBox = styled.div<IShareBox>`
  transition-duration: 0.3s;
  position: fixed;
  bottom: ${(props) => (props.show ? 0 : -200)}px;
  z-index: 1000;
  background-color: #fff;
  width: 100%;
  border-radius: 16px 16px 0 0;
  padding: 16px;
  box-shadow: 0px 0px 10px 10px #00000029;
  max-width: 576px;

  .social-medias {
    padding-bottom: 20px;

    > div {
      min-width: max-content;

      button + button {
        margin-left: 10px;
      }
    }
  }
`;

export const Circle = styled.div<ICircle>`
  background: ${(props) => props.color};
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Modal = styled(ModalComponent)`
  backdrop-filter: blur(3px);

  .modal-content {
    .btn-login {
      border-radius: 4px;
      background-color: #ff6900;
      color: #fff;
    }

    .bd-input {
      border: 1px solid #e1e1e1;
      height: 40px;
      border-radius: 4px;

      input {
        width: 100%;
        flex: 1;
        background: transparent;
        border: 0;
        color: #000;
        transition-duration: 0.2s;

        ::placeholder {
          color: #8c8c8c;
        }
      }
      svg:not(.check-icon, .rotate-arrow) {
        display: none;
      }
    }

    .select-tam input {
      font-size: 16px;
    }
  }
  .check span {
    color: #202020;
    font-size: 16px;
    font-weight: 400;
  }

  .copy-btn {
    border-radius: 4px;
    background-color: #ff6900;
    color: #fff;
  }

  .close-btn {
    position: absolute;
    top: 10px;
    right: 12px;
    border: none;
  }

  .bg-information {
    border-radius: 8px;
    background: #f6f6f6;
    padding: 16px;
  }
  .bg-white {
    border-radius: 8px;
  }
`;
